<template>
    <div class="flex justify-content-center aling-items-center banner-principal"></div>

    <div class="px-6 py-8 md:px-6 flex flex-column lg:px-7 bg-gray">
        <div class="flex align-items-center justify-content-center">
            <div class="w-81rem m-2 md:m-4 lg:my-1">
                <UserForm />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import UserForm from "../components/userForm.vue";
// import { Form as FORM, Field, ErrorMessage } from "vee-validate";

export default defineComponent({
    name: "FormClient",
    components: {
        UserForm,
    },
});
</script>

<style></style>
